import React from "react";
import Link from "next/link";
import Image from "next/image";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

interface Block {
  name: string;
  position: string;
  quaote: string;
  social_links: any[];
  image: {
    data: {
      attributes: {
        url: string;
      };
    };
  };
}
interface Props {
  block: Block;
}
const imgTypes: any = {
  email: "/images/leadership/mail-dark.svg",
  linkedin: "/images/leadership/linkedin-dark.svg",
};
const Banner: React.FC<Props> = ({ block }) => {
  const imageUrl = block?.image?.data?.attributes?.url;

  return (
    <>
      <section>
        <div className="leader-banner bg-background-dark pt-[120px] lg:pt-[150px] pb-[56px] lg:pb-[80px] xl:pb-[100px] relative z-0 overflow-hidden">
          {/* Shapes */}
          <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
            <Image
              src="/images/banner-left-layer-mobile.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-left-layer-tablet.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-left-layer-desktop.png"
              alt="Banner Shape"
              width={571}
              height={571}
              className="w-full h-full hidden lg:block"
            />
          </div>
          <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
            <Image
              src="/images/banner-right-layer-mobile.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full md:hidden"
            />
            <Image
              src="/images/banner-right-layer-tablet.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden md:block lg:hidden"
            />
            <Image
              src="/images/banner-right-layer-desktop.png"
              alt="Banner Shape"
              width={471}
              height={471}
              className="object-cover w-full h-full hidden lg:block"
            />
          </div>

          {/* Content */}
          <div className="container ">
            <div className="grid grid-cols-1 lg:[grid-template-columns:calc(60%-15px)_calc(40%-15px)] gap-[30px] z-1 items-center">
              <div className="relative z-[2] lg:pr-[60px] xl:pr-[180px] pr-[0px]">
                <h2 className="text-white font-bold text-heading-2 mb-[8px] lg:text-left text-center">
                  {block?.name ?? ""}
                </h2>
                <p
                  className=" lg:text-left text-center text-subtitle-1 font-regular text-transparent"
                  style={{
                    background:
                      "linear-gradient(10deg, #0086E6 3%, #8ABC00 62%)",
                    WebkitBackgroundClip: "text", // for Safari
                    backgroundClip: "text",
                  }}
                >
                  {block?.position ?? ""}
                </p>
                <div className="mt-[40px] relative">
                  <div className="mb-[-10px] relative left-[-10px]">
                    <Image
                      src="/images/leadership/quote.svg"
                      alt="quote"
                      width={60}
                      height={45}
                      className="object-cover w-[60px] h-[45px]"
                    />
                  </div>
                  <h4 className="lg:text-left text-center text-heading-5 font-semibold bg-[linear-gradient(96.14deg,#EDEDEE_0.73%,#878788_90.64%)] bg-clip-text text-transparent">
                    {block?.quaote ?? ""}
                  </h4>

                  <div className="flex gap-[20px] mt-[53px] lg:justify-start justify-center">
                    {block?.social_links?.map((item: any, index: number) => (
                      <Link
                        href={item?.href ?? "#"}
                        key={"social-link" + index}
                        className="w-[40px] h-[40px] border border-[#FFFFFF33] flex items-center justify-center cursor-pointer hover:border-[#8f8f8f] transition-all duration-500"
                      >
                        <Image
                          width={24}
                          height={24}
                          alt={item?.label ?? "social"}
                          className="object-cover w-[20px] h-[20px]"
                          src={
                            imgTypes[item?.label?.toLowerCase()] ?? imgTypes.linkedin
                          }
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex lg:justify-end justify-center pt-[60px] relative sm:left-[0] left-[20px]">
                <div className="relative">
                  <div className="absolute top-[-41px] left-[-41px] z-[-1]">
                    <Image
                      width={390}
                      height={500}
                      alt={block?.name ?? "banner-img"}
                      src="/images/leadership/banner-gr.png"
                      className="object-cover sm:w-[390px] sm:h-[500px] w-[240px] h-[300px]"
                    />
                  </div>
                  <div>
                    {imageUrl && (
                      <Image
                        width={390}
                        height={500}
                        src={baseUrl + imageUrl}
                        alt={block?.name ?? "banner-img"}
                        className="object-cover sm:w-[390px] sm:h-[500px] w-[240px] h-[300px]"
                      />
                    )}
                    {/* <div className="line w-[80px] h-[1px] bg-[#464953] absolute bottom-0 left-0"></div> */}
                    <div className="absolute bottom-0 -left-[27px] w-[55px] h-[1px] bg-[#464953] origin-center [transform:rotate(45deg)_translate(-28px,0)]"></div>
                    <div className="absolute top-0 -right-[27px] w-[55px] h-[1px] bg-[#464953] origin-center [transform:rotate(45deg)_translate(-28px,0)]"></div>
                    <div className="absolute top-[50%] right-[-100] lg:block hidden">
                      <Image
                        src="/images/leadership/banner-gr-arrow.svg"
                        alt="banner-arrow"
                        width={100}
                        height={1}
                        className="object-cover "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
